import "./bootstrap";
import "../css/app.css";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { createApp, h } from "vue";
import { createInertiaApp, router } from "@inertiajs/vue3";
import { createPinia } from "pinia";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import { useAuthStore } from "@/stores/authStore";

// Import and Initialize VForm
import Form from "vform";
window.Form = Form;

// Import and Initialize Tiny Emitter
import Emitter from "tiny-emitter";
window.emitter = new Emitter();

// Import and Initialize SweetAlert2
import Swal from "sweetalert2";
window.Swal = Swal;

const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
        toast.style.zIndex = "99999";
    },
});

window.Toast = Toast;

// Initialize Pinia
const pinia = createPinia();

// Set FontAwesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faFacebook,
    faXTwitter,
    faInstagram,
    faYoutube,
    faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import {
    faUserSecret,
    faPenToSquare,
    faCircleMinus,
    faUpRightAndDownLeftFromCenter,
    faDownload,
    faCalendarPlus,
    faMaximize,
    faMoneyBillWave,
    faArrowUpRightFromSquare,
    faBed,
    faShower,
    faBath,
    faLayerGroup,
    faChevronUp,
    faLocationCrosshairs,
    faMapPin,
    faCalendarAlt,
    faMapLocation,
    faCopy,
    faTrash,
    faTrashAlt,
    faReceipt,
    faCalendarDay,
    faImages,
    faShieldHalved,
    faBookOpenReader,
    faArrowRightArrowLeft,
    faUpDown,
    faArrowDownUpLock,
    faShuffle,
    faPenFancy,
    faLock,
    faChartLine,
    faStickyNote,
    faClipboardList,
    faListCheck,
    faPlusCircle,
    faPhone,
    faPhoneAlt,
    faSave,
    faListUl,
    faCircleCheck,
    faCircleXmark,
    faPaperPlane,
    faMoneyCheckAlt,
    faCommentAlt,
    faRoute,
    faUsers,
    faBolt,
    faHandHoldingDollar,
    faTrashCan,
    faPaperclip,
    faFilePdf,
    faLightbulb,
    faGlobe,
    faCloudUploadAlt,
    faLocationDot,
    faHandshake,
    faCompass,
    faBuilding,
    faIdCard,
    faAlignRight,
    faUserPen,
    faUserPlus,
    faCalendarCheck,
    faCalendarXmark,
    faCircleInfo,
    faUserShield,
    faUsersGear,
    faIcons,
    faHelmetSafety,
    faCity,
    faPeoplePulling,
    faHandshakeAngle,
    faMoneyBillWheat,
    faTriangleExclamation,
    faExclamation,
    faPlus,
    faRotateRight,
    faCircleQuestion,
    faBan,
    faCheckDouble,
    faBell,
    faHome,
    faDashboard,
    faBlog,
    faInfo,
    faTimes,
    faImage,
    faSearch,
    faSpinner,
    faFileSignature,
    faPrint,
    faInfoCircle,
    faCommentSlash,
    faPalette,
    faArrowRight,
    faFileInvoiceDollar,
    faBullhorn,
    faThumbtack,
    faUniversity,
    faSmile,
    faCommentDots,
    faFileAlt,
    faCalculator,
    faArrowsToEye,
    faEye,
    faCar,
    faChartSimple,
    faSun,
    faClock,
    faMoneyBillTransfer,
    faCircleExclamation,
    faBoxArchive,
    faInbox,
    faSortAmountDown,
    faSortAmountUp,
    faShield,
    faMoon,
    faKey,
    faCircleNotch,
    faUserSlash,
    faUserCheck,
    faUserTie,
    faUserGroup,
    faScroll,
    faSink,
    faFilter,
    faMagic,
    faSearchPlus,
    faRulerCombined,
    faMapLocationDot,
    faArrowsLeftRight,
    faExchangeAlt,
    faGears,
    faStamp,
    faUser,
    faCalendar,
    faChevronDown,
    faChevronRight,
    faChevronLeft,
    faAnglesRight,
    faAnglesLeft,
    faBriefcase,
    faStar,
    faSquarePollHorizontal,
    faComments,
    faHistory,
    faHandHoldingUsd,
    faFolderOpen,
    faLongArrowAltLeft,
    faFileContract,
    faSyncAlt,
    faHashtag,
    faCheck,
    faLanguage,
    faChartPie,
    faTags,
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faUserSecret,
    faPenToSquare,
    faCircleMinus,
    faUpRightAndDownLeftFromCenter,
    faDownload,
    faCalendarPlus,
    faMaximize,
    faMoneyBillWave,
    faArrowUpRightFromSquare,
    faBed,
    faShower,
    faBath,
    faLayerGroup,
    faChevronUp,
    faLocationCrosshairs,
    faMapPin,
    faCalendarAlt,
    faMapLocation,
    faCopy,
    faTrash,
    faTrashAlt,
    faReceipt,
    faCalendarDay,
    faImages,
    faShieldHalved,
    faBookOpenReader,
    faArrowRightArrowLeft,
    faUpDown,
    faArrowDownUpLock,
    faShuffle,
    faPenFancy,
    faLock,
    faChartLine,
    faStickyNote,
    faClipboardList,
    faListCheck,
    faPlusCircle,
    faPhone,
    faPhoneAlt,
    faSave,
    faListUl,
    faCircleCheck,
    faCircleXmark,
    faPaperPlane,
    faMoneyCheckAlt,
    faCommentAlt,
    faRoute,
    faUsers,
    faBolt,
    faHandHoldingDollar,
    faTrashCan,
    faPaperclip,
    faFilePdf,
    faLightbulb,
    faGlobe,
    faCloudUploadAlt,
    faLocationDot,
    faHandshake,
    faCompass,
    faBuilding,
    faIdCard,
    faAlignRight,
    faUserPen,
    faUserPlus,
    faCalendarCheck,
    faCalendarXmark,
    faCircleInfo,
    faUserShield,
    faUsersGear,
    faIcons,
    faHelmetSafety,
    faCity,
    faPeoplePulling,
    faHandshakeAngle,
    faMoneyBillWheat,
    faTriangleExclamation,
    faExclamation,
    faPlus,
    faRotateRight,
    faCircleQuestion,
    faBan,
    faCheckDouble,
    faBell,
    faHome,
    faDashboard,
    faBlog,
    faInfo,
    faTimes,
    faImage,
    faSearch,
    faSpinner,
    faFileSignature,
    faPrint,
    faInfoCircle,
    faCommentSlash,
    faPalette,
    faArrowRight,
    faFileInvoiceDollar,
    faBullhorn,
    faThumbtack,
    faUniversity,
    faSmile,
    faCommentDots,
    faFileAlt,
    faCalculator,
    faArrowsToEye,
    faEye,
    faCar,
    faChartSimple,
    faSun,
    faClock,
    faMoneyBillTransfer,
    faCircleExclamation,
    faBoxArchive,
    faInbox,
    faSortAmountDown,
    faSortAmountUp,
    faShield,
    faMoon,
    faKey,
    faCircleNotch,
    faUserSlash,
    faUserCheck,
    faUserTie,
    faUserGroup,
    faScroll,
    faSink,
    faFilter,
    faMagic,
    faSearchPlus,
    faRulerCombined,
    faMapLocationDot,
    faArrowsLeftRight,
    faExchangeAlt,
    faGears,
    faStamp,
    faUser,
    faCalendar,
    faChevronDown,
    faChevronRight,
    faChevronLeft,
    faAnglesRight,
    faAnglesLeft,
    faBriefcase,
    faStar,
    faSquarePollHorizontal,
    faComments,
    faHistory,
    faHandHoldingUsd,
    faFolderOpen,
    faLongArrowAltLeft,
    faFileContract,
    faSyncAlt,
    faHashtag,
    faCheck,
    faLanguage,
    faChartPie,
    faTags,
    faFacebook,
    faXTwitter,
    faInstagram,
    faYoutube,
    faTiktok,
);

// Set Title
const appName = import.meta.env.VITE_APP_NAME || "Laravel";

// Set Locale
let locale = localStorage.getItem("locale");
if (!locale) {
    localStorage.setItem("locale", "ar");
    locale = localStorage.getItem("locale");
}
window.locale = locale;

import { createI18n } from "vue-i18n/dist/vue-i18n.cjs";
import messages from "./messages";

const i18n = createI18n({
    locale: window.locale,
    fallbackLocale: "en",
    globalInjection: true,
    messages,
});

window.i18n = i18n;

// Create App
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue"),
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(pinia)
            .use(i18n)
            .use(plugin)
            .use(ZiggyVue, Ziggy);

        app.component("font-awesome-icon", FontAwesomeIcon);

        const authStore = useAuthStore();
        authStore.locale = window.locale;

        // استخراج اسم المسار الحالي لمعرفة إن كان المستخدم يحاول دخول لوحة التحكم
        const currentPath = window.location.pathname;
        const isAuthRoute =
            currentPath.includes("/login") || currentPath.includes("/register");

        // تحديد ما إذا كان المسار الحالي مساراً عاماً مفتوحاً للزوار (Public Route)
        const isPublicRoute =
            // currentPath === "/" ||
            currentPath.startsWith("/home") ||
            currentPath.startsWith("/project/") ||
            currentPath.startsWith("/survey");

        const token = props.initialPage.props.ziggy?.token;

        if (token) {
            authStore.setToken(token);
            window.axios.defaults.headers.common["Authorization"] =
                `Bearer ${token}`;
        } else {
            // حماية الواجهة: نتحقق أن المسار ليس مساراً عاماً، وليس صفحة تسجيل دخول، وليس الجذور لكي لا يطرد الزوار
            if (!isAuthRoute && !isPublicRoute && currentPath !== "/") {
                console.warn(
                    "Security Alert: Session is alive but Token is missing. Redirecting to login...",
                );

                // تفريغ الستور تماماً لإنهاء أي بيانات عالقة
                if (typeof authStore.logout === "function") {
                    authStore.logout();
                } else {
                    localStorage.removeItem("token");
                }

                // تحويل العميل بشكل كامل لخادم الـ Backend لتدمير جلسة الـ PHP Session والعودة لـ login
                window.location.href = "/login";
                return;
            }
        }

        // إعداد مراقب الأخطاء (Axios Interceptor) لمنع تعليق النظام عند انتهاء صلاحية التوكن فجأة
        window.axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response && error.response.status === 401) {
                    console.error(
                        "Token expired or invalid. Clearing application state...",
                    );
                    localStorage.removeItem("token");
                    window.location.href = "/login";
                }
                return Promise.reject(error);
            },
        );

        app.mount(el);
    },
    progress: {
        color: "#4B5563",
    },
});
